export enum EventEnum {
  APP_VISIT_0 = 'APP_VISIT_0',
  LOGIN_0 = 'LOGIN_0',
  SIGN_UP_0 = 'SIGN_UP_0',
  MESSAGE_SENT_0 = 'MESSAGE_SENT_0',
  INVITE_ACCEPTED_0 = 'INVITE_ACCEPTED_0',
}
